/**
 * OCR Validation Rules Configuration
 *
 * Each rule defines an OCR-based validation check that runs before product approval.
 * When a rule triggers, a confirmation modal is shown to the user.
 *
 * Rule properties:
 *   id          - Unique identifier for the rule
 *   ocrKeyword  - Word to search for in the OCR text (case-insensitive)
 *   productMatch - Function to identify if a product is in the target category.
 *                  Receives the brand_nm (lowercase). Return true if the product
 *                  is in the target category but does NOT contain the expected keyword.
 *   title       - Modal title
 *   message     - Modal warning message (plain text)
 *   linkText    - Optional link label shown in the modal
 *   linkUrl     - Optional methodology reference URL
 *
 * To add a new rule, simply add a new object to this array.
 */
export const OCR_VALIDATION_RULES = [
  {
    id: 'pesto',
    ocrKeyword: 'pesto',
    productMatch: (brandName) =>
      brandName.includes('pasta sauce') && !brandName.includes('pesto'),
    title: 'Pesto Mismatch Warning',
    message:
      "The OCR text contains 'pesto' but one or more selected products are pasta sauce without 'pesto'. Are you sure you want to approve?",
    linkText: 'Check Pasta Sauces Methodology',
    linkUrl:
      'https://sites.google.com/numerator.com/pep-consumables/consumables-food/dry-grocery/sauces-spreads/pasta-sauces',
  },
  {
    id: 'pepsi-prebiotic',
    ocrKeyword: 'pepsi',
    productMatch: (brandName) =>
      !brandName.includes('pepsi') || !brandName.includes('prebiotic'),
    title: 'Pepsi Prebiotic Mismatch Warning',
    message:
      "The OCR text contains both 'Pepsi' and 'Prebiotic' but one or more selected products do not contain both. Are you sure you want to approve?",
  },
  {
    id: 'pure-leaf-lipton',
    ocrKeyword: 'pure leaf',
    productMatch: (brandName) =>
      brandName.includes('lipton') && !brandName.includes('pure leaf'),
    title: 'Pure Leaf Lipton Mismatch Warning',
    message:
      "The OCR text contains 'Pure Leaf' but one or more selected products contain 'Lipton' without 'Pure Leaf'. Are you sure you want to approve?",
  },
  // Example: add more rules here
  // {
  //   id: 'organic',
  //   ocrKeyword: 'organic',
  //   productMatch: (brandName) =>
  //     brandName.includes('cereal') && !brandName.includes('organic'),
  //   title: 'Organic Mismatch Warning',
  //   message: "The OCR text contains 'organic' but the selected cereal product does not. Are you sure?",
  //   linkText: 'Check Cereal Methodology',
  //   linkUrl: 'https://example.com/cereal-methodology',
  // },
];
